/**
 * 公告栏
 */
import { FC, useState, useEffect } from 'react'
import { Button, Form, Modal, NoticeBar } from 'antd-mobile'
import { SoundOutline } from 'antd-mobile-icons'
import { useTranslation } from "react-i18next";
import { isEmpty, stripHTMLTags } from '@/utils'
import { useStoreState } from '@/store'
import css from './index.module.less'

export const Notice: FC = () => {
  const { t } = useTranslation();
  const { centerConfig }: any = useStoreState();
  const [visible, setVisible] = useState(false)

  // —— 1. 把 useEffect 移到这里（在任何 return 之前） ——
  useEffect(() => {
    // 只有当公告内容不为空时，才自动弹出 Modal
    if (!isEmpty(centerConfig.notice)) {
      setVisible(true)
    }
  }, [centerConfig.notice]) // 加上依赖项，当公告内容加载出来时触发弹出

  // —— 2. Hooks 全部声明完毕后，再进行条件返回 ——
  if (isEmpty(centerConfig.notice)) return null;

  const icon = process.env.REACT_APP_IDN_ENV === 'hw' ? <div className={css.Icon}></div> : <SoundOutline />;

  return (
    <>
      <div onClick={() => setVisible(true)}>
        <NoticeBar
          className={'mgt-5 mgb-20'}
          content={stripHTMLTags(centerConfig.notice)}
          color='alert'
          icon={icon}
        />
      </div>

      <Modal
        visible={visible}
        // showCloseButton
        // onClose={() => setVisible(false)}
        destroyOnClose
        content={
          <>
            <div dangerouslySetInnerHTML={{ __html: centerConfig.notice }}></div>
            <div className={'mgt-10'}>
              <Button block color='primary' className={'font-14'} onClick={() => setVisible(false)}>{t('common.know')}</Button>
            </div>
          </>
        }
      />
    </>
  )
}